import React from "react";
import { Oval } from "react-loader-spinner";

import colours from "../../../Common/DesignSystem/Colours";

export const SearchBar = ({ searching, searchTerm, setSearchTerm }) => (
	<div className="main-search-bar-container" style={{ width: '376px' }}>
		<input
			className="search-input-field"
			placeholder="Search Orders"
			value={searchTerm}
			onChange={(e) => {setSearchTerm(e.target.value)}}
		/>

		{searching && (
			<div className="search-loader-container">
				<Oval height={18} width={18} strokeWidth={4} color={colours.primary.blue} secondaryColor={colours.functional.hover_primaryblue} />
			</div>
		)}
	</div>
);
